jQuery(document).ready(function($) {
    if (typeof window.CAMPAIGN_DATA ===
        'undefined' ||
        !window.CAMPAIGN_DATA.item ||
        !window.CAMPAIGN_DATA.item[0]) {
        console.warn('Ingen CAMPAIGN_DATA hittades');
        return;
    }

    const feature = window.CAMPAIGN_DATA.item[0];

    window.svmInitHotelMap({
        center: feature.geometry.coordinates,
        isPromoted: feature.properties && feature.properties.is_promoted === 1,
        cooperativeGestures: !isMobile,
    });
});
